/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".qb-alert[_ngcontent-%COMP%]{position:fixed;width:500px;left:50%;margin-left:-250px;top:90px;z-index:1000;border-radius:0}.qb-alert.qb-alert-wide[_ngcontent-%COMP%]{width:700px;margin-left:-350px}"];
export { styles as styles };
